<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-download', fontSet: 'fad'}"
	[headerText]="T.EXPORT_RECORDING_DIALOG | translate"
	[matDialogData]="data"
	[rect]="rect"
>
	<ng-container dialogContent>
		<div class="exportsPanelWrapper h-100" style="contain: strict">
			<sim-scenario-archive-exports-panel
				[panelOpen]="true"
				[scenarioRecordingId]="data.scenarioRecordingId"
				[scenarioRecordingIdList]="data.scenarioRecordingIdList"
			/>
		</div>
	</ng-container>

	<ng-container actions>
		<sim-button (onClick)="close()" [icon]="{fontSet: 'fad', fontIcon: 'fa-times'}" [label]="T.BUTTON_CLOSE" color="warn" />
	</ng-container>
</sim-basic-material-dialog>
